import { styled } from '@mui/material';
import { Chart } from '@progress/kendo-react-charts';

export const ChartStyled = styled(Chart, {
  shouldForwardProp: (prop) =>
    prop !== 'isCard' &&
    prop !== 'isCardMobileList' &&
    prop !== 'isCardMobileDetails' &&
    prop !== 'isCardDashboardMobileList' &&
    prop !== 'hideChart',
})(({
  theme,
  isCard,
  isCardMobileList,
  isCardMobileDetails,
  isCardDashboardMobileList,
  hideChart,
}) => {
  const getElementOrder = () => {
    if (isCard)
      return {
        order: 3,
        maxHeight: '45px',
        marginBottom: '8px',
        [theme.breakpoints.down('lg')]: {
          maxHeight: '30px',
          marginBottom: '8px',
          maxWidth: '94.6px',
        },
      };

    if (isCardMobileList)
      return {
        order: 2,
        maxHeight: '50px',
        maxWidth: '100px',
        [theme.breakpoints.up('md')]: {
          maxWidth: '190px',
        },
      };

    if (isCardMobileDetails)
      return {
        order: 3,
        maxHeight: '30px',
        maxWidth: '130px',
        [theme.breakpoints.up('md')]: {
          maxWidth: '140px',
        },
      };

    if (isCardDashboardMobileList)
      return {
        maxHeight: '35px',
        maxWidth: '95px',
      };

    return {
      maxHeight: '55px',
      marginBottom: '16px',
      maxWidth: '178px',
      [theme.breakpoints.down('lg')]: {
        maxHeight: '30px',
        marginBottom: '8px',
        maxWidth: '94.6px',
      },
    };
  };

  return { ...getElementOrder(), display: hideChart && 'none' };
});
